/* ============
 * businessHours Transformer
 * ============
 */

import Transformer from './transformer';

export default class businessHoursTransformer extends Transformer {

  static fetch(businessHour) {
    return {
      id: businessHour.id,
      businessDays: businessHour.business_days,
      start: businessHour.start,
      end: businessHour.end,
    };
  }

  static send(businessHour) {
    return {
      id: businessHour.id,
      business_days: businessHour.businessDays,
      start: businessHour.start,
      end: businessHour.end,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/businessHour.js